<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    showBorder: {
      type: Boolean,
      default: false,
    },
    note: {
      type: String,
      default: '',
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div
    class="ml-0 mr-0 flex py-8 w-full flex-col xl:flex-row"
    :class="{
      'border-b border-solid border-n-weak/60 dark:border-n-weak w-full max-w-6xl mx-auto':
        showBorder,
    }"
  >
    <div class="flex flex-col gap-6 w-full">
      <div class="col-span-2">
        <div class="flex items-center justify-between">
          <div>
            <p
              v-if="title"
              class="text-base text-woot-500 dark:text-woot-500 mb-0 font-medium"
            >
              {{ title }}
            </p>
            <p
              class="text-sm mb-2 text-n-slate-11 leading-5 tracking-normal mt-2"
            >
              <slot v-if="subTitle" name="subTitle">
                {{ subTitle }}
              </slot>
            </p>
            <p v-if="note">
              <span class="font-semibold">{{ $t('INBOX_MGMT.NOTE') }}</span>
              {{ note }}
            </p>
          </div>
          <div class="flex-shrink-0">
            <slot name="headerActions" />
          </div>
        </div>
      </div>
      <div class="col-span-4">
        <slot />
      </div>
    </div>
  </div>
</template>
